import { S as Swiper } from './swiper-core-ClzX336E.js';
import { P as Pagination } from './pagination-BYB1eQGc.js';
import './classes-to-selector-B0Ehowsi.js';
import './create-element-if-not-defined-CpMCDYSa.js';

class FeaturedCollectionSlider extends HTMLElement {
  connectedCallback() {
    // Wait for next frame to ensure container has dimensions
    requestAnimationFrame(() => {
      this.initSwiper();
    });
  }

  initSwiper() {
    const swiperElement = this.querySelector('.swiper--featured-collection');

    if (!swiperElement) {
      return;
    }

    const slides = swiperElement ? Array.from(swiperElement.querySelectorAll('.swiper-slide')) : [];
    const loopSetting = this.dataset.loop === 'true';
    const pagination = this.dataset.pagination === 'true';

    const config = {
      modules: [Pagination],
      spaceBetween: 16,
      slidesPerView: 1.2,
      loop: loopSetting && slides.length > 1,
      breakpoints: {
        768: {
          slidesPerView: 2.2,
          loop: loopSetting && slides.length > 2,
        },
        1024: {
          slidesPerView: 4.2,
          loop: loopSetting && slides.length > 4,
        },
        1440: {
          slidesPerView: 5,
          loop: loopSetting && slides.length > 5,
        },
      },
    };

    if (pagination) {
      config.pagination = {
        el: '.swiper-pagination',
        clickable: true,
      };
    }

    this.swiper = new Swiper(swiperElement, config);
  }
}

customElements.define('featured-collection-slider', FeaturedCollectionSlider);
